



























































































import Vue from "vue";

import { LMap, LTileLayer, LMarker, LIcon, LPolygon } from "vue2-leaflet";
import { LatLng, latLng, LatLngBounds, latLngBounds, LocationEvent } from "leaflet";

import PopupMap from "@/components/Map/PopupMap.vue";

import { Location_, IMapDataDefinition } from "@/types/types";
import { IMapData } from "@/types/interface";

export default Vue.extend({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    PopupMap,
    LIcon,
    LPolygon
  },
  props: {
    datas: {
      type: Array as () => Array<IMapDataDefinition>
    },
    zoom: {
      type: Number,
      default: 5
    },
    center: {
      type: Array,
      default: () => [48.856614, 2.3522219]
    }
  },
  data(): IMapData {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      tileOptions: {
        maxNativeZoom: 18,
        maxZoom: 21
      },
      iconSize: 48,
      arrowSize: 36,
      zoomMap: this.zoom
    };
  },
  methods: {
    polygonLocation(polygon_location: Array<Location_>): Array<Array<number>> {
      return polygon_location.map((location) => [location.latitude as number, location.longitude as number]);
    },
    onMapClick(event: LocationEvent) {
      this.$emit("mapClick", event.latlng);
    },
    onMapMoving(event: LocationEvent) {
      this.$emit("mapMoving", event.latlng);
    },
    onMapZoom(zoom: number) {
      this.zoomMap = zoom;
    }
  },
  computed: {
    dynamicSize(): Array<number> {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicArrowSize(): Array<number> {
      return [this.arrowSize, this.arrowSize * 1.15];
    },
    /**
     * @description this function is used to calculate the bounds of the map to fit all the markers
     *  if there is no markers, the function will return a null value and the default way to center the map will be used
     *
     * @returns LatLngBounds | null
     */
    bounds(): LatLngBounds | null {
      let mapPoints: Array<LatLng> = this.mapPointsLocations;
      let mapBounds = mapPoints.length === 0 ? null : latLngBounds(mapPoints);
      if (mapBounds) {
        // When bounds are calculated, we add a little padding to the map so the marker will be completely visible
        mapBounds.pad(0.2);
        return mapBounds;
      }
      return null;
    },
    /**
     * @description this function is used to get all the markers locations
     *
     * @returns Array<LatLng>
     */
    mapPointsLocations(): Array<LatLng> {
      let mapPoints: Array<LatLng> = [];
      this.datas.forEach((mapData: IMapDataDefinition) => {
        if (mapData.location)
          mapPoints.push(latLng(mapData.location.latitude as number, mapData.location.longitude as number));
        if (mapData.theoretical_location)
          mapPoints.push(
            latLng(mapData.theoretical_location.latitude as number, mapData.theoretical_location.longitude as number)
          );
      });
      return mapPoints;
    }
  }
});
